var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yj-color-svpanel",style:({
      backgroundColor: _vm.background
    })},[_c('div',{staticClass:"yj-color-svpanel__white"}),_vm._v(" "),_c('div',{staticClass:"yj-color-svpanel__black"}),_vm._v(" "),_c('div',{staticClass:"yj-color-svpanel__cursor",style:({
      top: _vm.cursorTop + 'px',
      left: _vm.cursorLeft + 'px'
    })},[_c('div')])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/color-picker/src/components/sv-panel.vue